import { useEffect, useState } from "react";
import clsx from "clsx";
import { TooltipComponent } from "../../components/ui/Tooltip";
import { InfoIcon } from "../../icons";
import Loader from "../../components/elements/loader";
import { useGetCarIconInfo, useGetCarIcons } from "../../hooks/react-query/useNotificationsGuide";

export const NotificationsGuide = () => {
    const [selectedIcon, setSelectedIcon] = useState(null)
    const [carIconsList, setCarIconsList] = useState([])
    const [message, setMessage] = useState();

    const {data, isLoading: isCarIconsListLoading} = useGetCarIcons()

    const { mutate: getIconMessage, isLoading: isIconMessageLoading } = useGetCarIconInfo()
    
    useEffect(()=>{
        if(data?.data?.length > 0) {
            setCarIconsList(data.data)
        }
    },[data])

    useEffect(() => {
        const fetchIconMessage = async () => {
            if (!selectedIcon) return;
                try {
                    getIconMessage([selectedIcon],
                        {
                            onSuccess : (response) => {
                                setMessage(response?.data?.systemAction)
                            }
                        });
                } catch (e) {
                    console.warn(e);
                }
            };
        fetchIconMessage();
    }, [getIconMessage, selectedIcon]);


    const handleSubmit = (list) => {
        try {
            getIconMessage(list,
            {
                onSuccess : (response) => {
                    setMessage(response?.data?.systemAction)
                }
            });
        } catch (e) {
            console.warn(e);
        }
    }

    return (
       <div className="flex items-center flex-col gap-5 container mx-auto max-md:px-10 h-fit" style={{ minHeight: 'calc(100vh - 140px)' }}>
            <div className="flex gap-2 items-center w-full pt-6">
                {/* <LeftArrow className={'cursor-pointer'} onClick={()=>{navigate('/')}}/> */}
                <p className="h3">Οδηγός Ενδείξεων</p>
            </div>
            <div className="flex w-full gap-6 mb-6">
                <div className="flex flex-col gap-8 w-full lg:w-fit">
                    <div className="p-6 bg-[#F5F5F7] flex flex-col gap-3 rounded-[12px] border border-[#A5A5A5]">
                        <h4>Oδηγίες</h4>
                        <div className="text-body-large">
                            <p className="text-body">• Θέσε τον κινητήρα σε λειτουργία.</p>
                            <p  className="text-body">• Περίμενε για 30 δευτερόλεπτα.</p>
                            <p  className="text-body">• Από τον παρακάτω πίνακα, επίλεξε τα εικονίδια που εμφανίζονται στον πίνακα οργάνων του αυτοκινήτου.</p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-8 max-lg:gap-4 max-lg:mx-auto max-lg:items-center">
                        <h4>Επίλεξε την ένδειξη που εμφανίζεται</h4>
                        <div className="w-fit grid grid-cols-6 gap-3 lg:gap-5 items-center">
                            
                            {carIconsList && carIconsList.map(item =>
                                <TooltipComponent content={item.label}>
                                    <img alt='' width={60} onClick={() => {!isIconMessageLoading && setSelectedIcon(item.id)}} key={item.id} className={clsx("rounded-[6px] cursor-pointer border border-2",carIconsList.find(select => select === item.id) !== undefined ? 'border-[#FF0000]' : 'border-transparent')} src={item.url} />
                                </TooltipComponent>
                            )}
                        </div>
                        <p className="text-[#6A6A6A] text-disclaimer">Αν δεν βλέπεις τη λυχνία παραπάνω πάτησε
                            <span className="text-[#D4002A] cursor-pointer" onClick={() => handleSubmit(['other-red'])}> εδώ </span>
                            για κόκκινη ένδειξη και
                            <span className="text-[#D4002A] cursor-pointer" onClick={() => handleSubmit(["other-yellow-orange"])}> εδώ </span>
                            για κίτρινη ή πορτοκαλί ένδειξη.
                        </p>
                    </div>
                </div>

                {/* desktop message block */}
                <div className="w-[626px] rounded-[12px] border border-[#A5A5A5] flex flex-col gap-6 items-center justify-center p-10 max-lg:hidden">
                    <InfoIcon className={'w-12 h-12'} />
                    <p className="text-center text-body-large">{message === undefined ? 'Επίλεξε μία από τις ενδείξεις αριστερά για περισσότερες λεπτομέρειες' : message.label}</p>
                    {message && message.phone && <h4>{message.phone}</h4>}
                    {(isCarIconsListLoading || isIconMessageLoading) && <Loader />}
                </div>
            </div>

            {/* mobile sticky bottom message bar */}
            {!!message && <div className="fixed bottom-0 w-full lg:hidden bg-white border-t border-[#A5A5A5] pt-6 pb-16 px-5" style={{
                boxShadow: '0px -8px 10px 0px #0000000D'
            }}>
                {isIconMessageLoading ? <div
                    className="animate-pulse bg-powdergrey h-5 rounded-md"
                /> : !!message 
                        ? <div className='flex flex-row gap-5 items-center justify-center'>
                            <InfoIcon className={'w-7 h-7 shrink-0'} />
                            <p>{message.label} {!!message?.phone ? message?.phone : ""}</p>
                            </div>
                        : <></>}
            </div>}
        </div>
    )
}